var video_viewer_default = {
  "video_player": "n5a0Z",
  "videoOverlay": "_0oWJ7",
  "video_container": "ndwDX"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
